import React from 'react'
import { connect } from 'react-redux'
import { fetchGroups } from '../../actions/group-actions'
import { Grid, Row, Table } from 'react-bootstrap'
import qs from 'qs'

import SearchBar from '../../components/SearchBar'
import Breadcrumbs from '../../components/Breadcrumbs'
import * as Util from '../../services/util'

import { SEARCH_INSTRUCTIONS, NO_SEARCH_RESULTS } from '../messages'

class GroupOverview extends React.Component {
  constructor() {
    super()
    this.state = { query: undefined }
  }

  componentDidMount() {
    if (this.props.location.search) {
      let params = qs.parse(this.props.location.search.substring(1))
      this.setState({ query: params.query })
      this.props.fetchGroups(params.query)
    }
  }

  search(query) {
    this.props.fetchGroups(query)
  }

  render() {
    const { searchResults } = this.props

    return (
      <Grid>
        <Breadcrumbs />
        <SearchBar
          value={this.state.query || searchResults.query}
          action="/groepen"
          placeholder="Zoek groep"
          callback={(query) => this.search(query)}
        />

        <Row>
          <div className="tablescontainer">
            {searchResults.length > 0 ? (
              <Table striped>
                <thead>
                  <tr>
                    <th>Naam</th>
                    <th>Klant</th>
                    <th>Werkmaatschappij</th>
                  </tr>
                </thead>
                <tbody>
                  {searchResults.map((group, index) => (
                    <tr key={index} onClick={() => Util.validateIpAddress(searchResults.query) ? this.props.history.push(`/groepen/${group.id}?selectedIp=${searchResults.query}`) : this.props.history.push(`/groepen/${group.id}`) }>
                      <td>{group.name}</td>
                      <td>{group.customer.name}</td>
                      <td>{group.customer.identityProvider.subsidiary.name}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <SearchInfo />
            )}
          </div>
        </Row>
      </Grid>
    )
  }
}

let SearchInfo = () => (
  <div>
    <p>{SEARCH_INSTRUCTIONS}</p>
    <p>Zoek op:</p>
    <ul>
      <li>Groepsnaam</li>
      <li>Klantnaam</li>
      <li>IP-adres</li>
      <li>IP Range naam</li>
      <li>
        Product
        <ul>
          <li>Naam</li>
          <li>EAN</li>
        </ul>
      </li>
    </ul>
    <p>{NO_SEARCH_RESULTS}</p>
  </div>
)

export default connect(
  (state) => {
    return { searchResults: state.groups.searchResults }
  },
  {
    fetchGroups,
  }
)(GroupOverview)
